import { intl } from "LocaleWrapper";
import { Typography } from "@mui/material";
import {
	TimelineItem,
	TimelineSeparator,
	TimelineConnector,
	TimelineContent,
	TimelineOppositeContent,
	TimelineDot,
} from "@mui/lab";
import { DataFormat } from "imports/Utils";
import { FormattedCalendarDate } from "utils/DateUtils";
import { AnglerEvents, getInitialTagSettings, VoyagePlanBridgeEvent } from "../../AnglerUtils";

const AnglerTimelineBridgeEvent = ({ event }: { event: VoyagePlanBridgeEvent }) => {
	return (
		<TimelineItem>
			<TimelineOppositeContent sx={{ m: "auto 0" }}>
				<Typography variant="h6" color="textPrimary" sx={{ fontSize: 12 }}>
					<FormattedCalendarDate date={event.startTime} />
				</Typography>
			</TimelineOppositeContent>

			<TimelineSeparator>
				<TimelineConnector />
				<TimelineDot sx={{ backgroundColor: getInitialTagSettings()[AnglerEvents.Bridge].color }}>
					{getInitialTagSettings()[AnglerEvents.Bridge].icon}
				</TimelineDot>
				<TimelineConnector />
			</TimelineSeparator>

			<TimelineContent sx={{ m: "auto 0" }}>
				<Typography variant="h6" color="textPrimary" sx={{ fontSize: 12 }}>
					{event.name}
				</Typography>

				{event.heightCm && (
					<Typography variant="h6" color="textSecondary" sx={{ fontSize: 11 }}>
						{`${intl.formatMessage({ id: "BRIDGE_HEIGHT_IS" })} ${DataFormat.simpleUnit(event.heightCm, DataFormat.UNITS.CENTIMETER)}`}
					</Typography>
				)}
			</TimelineContent>
		</TimelineItem>
	);
};

export default AnglerTimelineBridgeEvent;
